<div *ngIf="noEvents">
  <div class="col-4 offset-4 marTB8">
    <h5 class="H5Header marL16 marT32 center" name="noeventheading">
      <strong name="noevent">No events mapped</strong>
    </h5>
  </div>
</div>
<div *ngIf="!noEvents">
  <mat-tab-group (selectedTabChange)="onTabChanged($event)" id="evntsTabId" [selectedIndex]="selectedIndex">
    <mat-tab *ngFor="let detail of eventData" [label]="detail.eventId">
      <ng-template class="all" mat-tab-label *ngIf="detail.eventId === 0">
        <h5 name="eventheading">
          <strong class="def" id="eventdetail{{ detail.value }}"> {{ detail.value | titlecase }} </strong>
        </h5>
      </ng-template>
      <ng-template mat-tab-label *ngIf="detail.eventId !== 0">
        <div class="container">
          <div class="row align">
            <div class="col-3 nopadR">
              <strong class="Me-PrimaryDark date" id="eventdate{{ detail.eventDate }}">{{
                detail.eventDate | date: 'd'
              }}</strong>
            </div>
            &nbsp;&nbsp;
            <div class="col-3 nopadLR">
              <div class="desc">
                <strong id="eventdes{{ detail.eventDesc }}"> {{ detail.eventDesc | titlecase }} </strong>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-2 nopadR">
              <div class="month nomar" id="detaildate{{ detail.eventDate }}">
                {{ detail.eventDate | date: 'MMM' | uppercase }}
              </div>
            </div>
            &nbsp;&nbsp;
            <div class="offset-1 afterFlow">
              <img class="icon" src="assets/images/icons/default_icons/icon-location.png" alt="icon-location" />
            </div>
            <div class="location" id="eventcity{{ detail.eventCity }}">{{ detail.eventCity }}</div>
          </div>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
